module.exports = __webpack_public_path__ + "img/Pancake-flip-2-1200-COMPRESSED-CROPPED.5932cb2a.gif";